<template>
  <div
    class="warning-box"
    :class="{ danger }"
  >
    <i class="fa-regular fa-triangle-exclamation" />
    <span
      v-if="location"
      class="font-weight-bold pr-1"
    >{{ location }}</span>
    <span v-if="type === 'Other'">{{ reference }}</span>
    <span v-else>
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    reference: String,
    row: Number,
    column: String,
    // sent by the API with each error, only `danger` changes the look
    warning: Boolean,
    danger: Boolean,
    translationKey: {
      type: String,
      default: 'shop.error',
    },
  },
  computed: {
    location() {
      if (this.row && this.column) {
        return this.$t('import.location.rowColumn', { row: this.row, column: this.column });
      }
      if (this.row) {
        return this.$t('import.location.row', { row: this.row });
      }
      if (this.column) {
        return this.$t('import.location.column', { column: this.column });
      }
      return null;
    },
    message() {
      const key = `${this.translationKey}.${this.type}`;
      if (this.$te(key)) {
        return this.$t(key, [this.reference]);
      }
      // errors shared by all spreadsheet imports
      return this.$t(`import.error.${this.type}`, [this.reference]);
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-box {
  background-color: rgba($orange, 0.1);
  margin-top: 5px;
  border-radius: 5px;
  padding: 10px 15px;

  i {
    color: $orange;
    font-size: 25px;
    padding-right: 10px;
  }

  &.danger {
    background-color: rgba($red, 0.1);

    i {
      color: $red;
    }
  }
}
</style>
